import * as yup from 'yup';
import { DispenseSystemType, VenueType, WaterHardnessType } from '../types';

const latLngRegex = /^-?([1-8]?[0-9]|[1-9])[.]{1}\d+/;

export const createVenueDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  clientId: yup.string().required().label('Client'),
  contacts: yup.array().of(yup.string().required()).required().label('Contacts'),
  address: yup.string().label('Address'),
  town: yup.string().label('Town'),
  county: yup.string().label('County'),
  country: yup.string().label('Country'),
  postCode: yup.string().label('Post code'),
  isPss: yup.boolean().nullable().label('Pre Survey Setup').default(false),
  venueDescription: yup.string().label('Venue description'),
  mobilePhone: yup.string().label('Phone'),
  coordinatesLat: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test('lat-test', 'Latitude must be of valid format!', (value) => {
      return !value || latLngRegex.test(value.toString());
    }),
  coordinatesLng: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test('lat-test', 'Latitude must be of valid format!', (value) => {
      return !value || latLngRegex.test(value.toString());
    }),
  accessWindowOpen: yup.string().nullable().default(null),
  accessWindowClose: yup.string().nullable().default(null),
  licenseOpen: yup.string().nullable().default(null),
  licenseClose: yup.string().nullable().default(null),
  productDeliveryDays: yup.array().label('Product delivery days'),
  accessDays: yup.array().label('Access days'),
  waterHardness: yup
    .mixed<WaterHardnessType>()
    .test('water-hardness-test', 'Invalid water hardness value', (value) => {
      return !value || Object.values(WaterHardnessType).includes(value);
    })
    .nullable()
    .label('Water hardness'),
  venueType: yup.mixed<VenueType>().oneOf(Object.values(VenueType)).nullable().label('Venue type'),
  dispenseSystem: yup
    .mixed<DispenseSystemType>()
    .oneOf(Object.values(DispenseSystemType))
    .nullable()
    .label('Dispense system')
});

export const updateVenueDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  clientId: yup.string().required().label('Client'),
  contacts: yup.array().of(yup.string().required()).required().label('Contacts'),
  address: yup.string().nullable().label('Address'),
  town: yup.string().nullable().label('Town'),
  county: yup.string().nullable().label('County'),
  country: yup.string().nullable().label('Country'),
  postCode: yup.string().nullable().label('Post code'),
  isPss: yup.boolean().nullable().label('Pre Survey Setup'),
  venueDescription: yup.string().nullable().label('Venue description'),
  mobilePhone: yup.string().nullable().label('Phone'),
  coordinatesLat: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test('lat-test', 'Latitude must be of valid format!', (value) => {
      return !value || latLngRegex.test(value.toString());
    }),
  coordinatesLng: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .test('lat-test', 'Latitude must be of valid format!', (value) => {
      return !value || latLngRegex.test(value.toString());
    }),
  dispenseSystem: yup
    .mixed<DispenseSystemType>()
    .oneOf(Object.values(DispenseSystemType))
    .nullable()
    .label('Dispense system'),
  accessWindowOpen: yup.string().nullable().default(null),
  accessWindowClose: yup.string().nullable().default(null),
  licenseOpen: yup.string().nullable().default(null),
  licenseClose: yup.string().nullable().default(null),
  productDeliveryDays: yup.array().nullable().label('Product delivery days'),
  accessDays: yup.array().nullable().label('Access days'),
  waterHardness: yup
    .mixed<WaterHardnessType>()
    .test('water-hardness-test', 'Invalid water hardness value', (value) => {
      return !value || Object.values(WaterHardnessType).includes(value);
    })
    .nullable()
    .label('Water hardness'),
  venueType: yup.mixed<VenueType>().oneOf(Object.values(VenueType)).nullable().label('Venue type')
});
